import { iopsApi } from 'api';
import { prosealApi } from 'common/pages/fleetV2/machine/proseal/api';
import { dsiApi } from 'common/pages/fleetV2/machine/dsi/api';
import { default as error } from './error';

export default [iopsApi.middleware, prosealApi.middleware, dsiApi.middleware, error];
